(function () {
	'use strict';

	angular.module('jcsfApp').directive('dialog', dialog);

	dialog.$inject = ['messaging', 'events'];

	function dialog(messaging, events) {
		var directive = {
			restrict: 'EA',
			replace: true,
			templateUrl: '/app/directives/dialog/dialog.html',
			link: function (scope, element) {
				scope.packet = {};
				scope.modalType = 'popup';
				scope.message = '';
				scope.heading = 'Please Confirm';
				scope.selectreason = '';
				scope.reason = '';
				scope.valid = false;

				var showConfirmationInputHandler = function (
					messageText,
					headingText,
					packet
				) {
					// got the request start notification, show the element
					scope.message = messageText;
					scope.heading = headingText;
					scope.packet = packet;
					scope.selectreason = '';
					scope.reason = '';
					scope.valid = packet.valid;

					element.modal('show');
				};

				scope.showConfirmationInputHandle = messaging.subscribe(
					events.message._DISPLAY_CONFIRMATION_INPUT_,
					showConfirmationInputHandler
				);

				scope.$on('$destroy', function () {
					messaging.unsubscribe(scope.showConfirmationHandle);
					messaging.unsubscribe(scope.showConfirmationInputHandle);
				});

				scope.confirm = function () {
					element.modal('hide');
					messaging.publish(events.message._USER_RESPONDED_, [
						{
							answer: 'YES',
							selectreason: scope.selectreason,
							reason: scope.reason,
						},
					]);
				};

				scope.close = function () {
					element.modal('hide');
					messaging.publish(events.message._USER_RESPONDED_, [
						{ answer: 'NO' },
					]);
				};
			},
		};
		return directive;
	}
})();
